<template>
  <div v-if="data">
    <div class="flex break-inside-avoid flex-col items-center pt-40">
      <BaseMemberAvatar v-if="memberWithAvatar" :member="memberWithAvatar" size="128" />
      <h1 class="text-display-medium mt-4">
        Profil von {{ memberFullName(data.member) }}
      </h1>
      <p class="text-body-large text-on-surface-variant mt-2">
        Stand:
        {{
          useDisplayDate(new Date(), {
            dayName: 'none',
            monthName: 'number',
            year: 'short',
            displayYear: 'always',
          })
        }}
      </p>
    </div>
    <div v-for="slide in data.slides" :key="slide.feedbackTopic.id" class="break-before-page">
      <h2 class="text-headline-large mb-10">{{ slide.feedbackTopic.title }}</h2>
      <PrintJournalProfile
        v-if="slide.type === FeedbackTopicType.Journal"
        :feedback-topic="slide.feedbackTopic"
        :latest-value="slide.analysis.latestValue"
        :progress="slide.analysis.progress"
        :questions="slide.analysis.questions"
        :scale="slide.analysis.scale"
      />
      <PrintEvaluationProfile
        v-if="slide.type === FeedbackTopicType.Evaluation"
        :feedback-topic="slide.feedbackTopic"
        :analysis="slide.analysis"
      />
    </div>
  </div>
</template>
<script lang="ts" setup>
  import BaseMemberAvatar from '@/core/components/base/avatar/BaseMemberAvatar.vue'
  import { usePrintCoacheeProfile } from '../composables/use-print-coachee-profile'
  import { useDisplayDate } from '@/core/composables/use-display-date'
  import { computed } from 'vue'
  import PrintJournalProfile from '../../profile/components/PrintJournalProfile.vue'
  import { FeedbackTopicType } from '@/core/models/feedback-topic'
  import PrintEvaluationProfile from '../../profile/components/PrintEvaluationProfile.vue'
  import { memberFullName } from '@/core/models/member/member-name'

  const { data } = usePrintCoacheeProfile()

  const memberWithAvatar = computed(() => {
    if (!data.value) {
      return null
    }
    return {
      ...data.value!.member,
      avatarFileContent: data.value!.memberAvatar!,
    }
  })
</script>
